import { useTranslation } from 'react-i18next';

export default function LanguageSwitcher() {
  const { i18n } = useTranslation();

  const languages = [
    { code: 'en', label: 'EN', name: 'English' },
    { code: 'zh', label: '中文', name: 'Traditional Chinese' },
    { code: 'th', label: 'ไทย', name: 'Thai' },
  ];

  const currentLanguage = i18n.language;

  return (
    <div className="flex items-center gap-1">
      {languages.map((lang) => (
        <button
          key={lang.code}
          onClick={() => i18n.changeLanguage(lang.code)}
          className={`px-2 py-1 text-xs font-medium rounded transition-colors ${
            currentLanguage === lang.code
              ? 'bg-seal-red text-white'
              : 'text-mist-gray hover:text-ink-black hover:bg-aged-paper'
          }`}
          title={lang.name}
        >
          {lang.label}
        </button>
      ))}
    </div>
  );
}
